import { useState } from "react";
import Scroll from "../../../../ui/scroll/Scroll";
import Text from "../../../../features/text/Text";
import classes from "./SectionList.module.css";

const SectionList = ({ titel, list = [], ItemComponent, classNameList, itemPropName, textForEmptyList, imgEmptyList, AddItemComponent, classNameForEmptyList }) => {

    return (
        <>
            <div className={classes.SectionHeader}>
                <p className={classes.SectionTitle}>{titel}</p>
            </div>
            <Scroll height={"100%"}>
                <div className={`${classNameList || classNameForEmptyList}`}>
                    {AddItemComponent && <AddItemComponent />}
                    {list?.length > 0 ?
                        list.map((item, index) => (
                            <ItemComponent key={index} {...{ [itemPropName]: item }} />
                        ))
                        :
                        (textForEmptyList || imgEmptyList) &&
                        <div className={`${classes.EmptyStateWrapper}`}>
                            {textForEmptyList && <Text className={classes.EmptyState}>{textForEmptyList}</Text>}
                            {imgEmptyList && <img src={imgEmptyList} alt={textForEmptyList} className={classes.EmptyStateImg} />}
                        </div>
                    }
                </div>
            </Scroll >
        </>
    );
};

export default SectionList;
